import { WorkSpace } from 'Constants/WorkSpace'
import { TypeOfChannel } from 'Slices/Omnichannel/DiscountSlice'

const retrieveSelectedArticleKey = (rowKeysSelected: number[]) => {
  return rowKeysSelected && rowKeysSelected.length === 1 ? rowKeysSelected[0] : null
}

const workspacesToExclude = (value: WorkSpace) => {
  const workspaces = [WorkSpace.WEB, WorkSpace.B2B, WorkSpace.MARKETPLACE, WorkSpace.STORE]
  return workspaces.includes(value)
}

const checkPricelistVisibilityOnFilters = (
  typeOfChannel: TypeOfChannel,
  currentWorkspace: WorkSpace,
  pricelistName: string,
) => {
  switch (currentWorkspace) {
    case WorkSpace.STOREMANAGER:
      return typeOfChannel === TypeOfChannel.Store || pricelistName === 'M/V'
    case WorkSpace.OMNICHANNEL:
      return !(typeOfChannel === TypeOfChannel.Store)
    case WorkSpace.STORE:
      return false
    default:
      return true
  }
}

export { retrieveSelectedArticleKey, workspacesToExclude, checkPricelistVisibilityOnFilters }
